import request from '@/router/axios';
// 首页
export const pUserShortcut = (data) => {
  return request({
    url: '/api/blade-system/usual/api/pUserShortcut',
    method: 'post',
    data,
  })
}
// 首页取链接系统接口
export const pGetSystem = (data) => {
  return request({
    url: '/api/blade-system/usual/api/pGetSystem',
    method: 'post',
    data,
  })
}
// 首页取常用外部链接接口
export const pGetLink = (data) => {
  return request({
    url: '/api/blade-system/usual/api/pGetLink',
    method: 'post',
    data,
  })
}
// 快捷方式
export const pUserShortcut1 = (data) => {
  return request({
    url: '/api/blade-system/usual/api/pUserShortcut1',
    method: 'post',
    data,
  })
}
// 首页
export const pTodoUserType = (data) => {
  return request({
    url: '/api/blade-system/usual/api/pTodoUserType',
    method: 'post',
    data,
  })
}
// 首页
export const pTodoDtl = (data) => {
  return request({
    url: '/api/blade-system/usual/api/pTodoDtl',
    method: 'post',
    data,
  })
}
// 首页
export const pTodoUserSetup = (data) => {
  return request({
    url: '/api/blade-system/usual/api/pTodoUserSetup',
    method: 'post',
    data,
  })
}
// 首页
export const processDeal = (data, obj = {}) => {
  return request({
    url: '/api/blade-system/api/processDeal/usual',
    method: 'post',
    data,
  })
}
// 待办明细
export const getTpdoDtl = (data) => {
  return request({
    url: '/api/blade-system/usual/api/getTpdoDtl',
    method: 'post',
    data,
  })
}
// 获取提醒明细
export const getAlertDtl = (data) => {
  return request({
    url: '/api/blade-system/usual/api/getAlertDtl',
    method: 'post',
    data,
  })
}
// 删除待办明细
export const delTpdoDtl = (data) => {
  return request({
    url: '/api/blade-system/usual/api/delTodoDtl',
    method: 'post',
    data,
  })
}
// 删除提醒
export const delAlert = (data) => {
  return request({
    url: '/api/blade-system/usual/api/delAlert',
    method: 'post',
    data,
  })
}
